import { render } from "./FacilityList.vue?vue&type=template&id=2edc49c7&scoped=true"
import script from "./FacilityList.vue?vue&type=script&lang=js"
export * from "./FacilityList.vue?vue&type=script&lang=js"

import "./FacilityList.vue?vue&type=style&index=0&id=2edc49c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edc49c7"]])

export default __exports__